import { request } from "services/api/util";

class ProductDisplayNameService {
  async getListImportFileStatus() {
    const config = {
      method: "get",
      url: `admin/productDisplayName/importStatus`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async uploadProductDisplayName(body) {
    const config = {
      method: "post",
      url: `admin/productDisplayName`,
      data: body,
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return request(config);
  }
}

export default new ProductDisplayNameService();
